


















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { doublePrevention, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class TaskAbnormalDialog extends Vue {
  private visible = false;
  imgPath: any = 'data:image/jpeg;base64,';
  picPath: any = '';
  formData: any = {};

  userRules: any = {};
  imagesList: any = [];

  headers: any = {};
  actionUrl: any = '';
  private fileList: any = [];

  private imageForm: any = {
    id: '',
    images: '',
  };

  private async showAddDialog(data: any) {
    // this.imagesList = [];
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.picPath = publishObjectPath.imgPathWater;
    this.getPatrolHazardCheckData(data.id);
    this.visible = true;
  }

  getPatrolHazardCheckData(id: any) {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getPatrolHazardCheckShellDetail(id)
      .then(async (res: any) => {
        this.formData = res.data;
        this.imageForm.id = res.data.id;
        const resInner: any = await this.getSignatureData(res.data.staffSign);
        this.formData.staffSign = resInner.signature;
        if (res.data.images) {
          this.getSysFile(res.data.images);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  getSysFile(id: any) {
    performanceServer.getSysFile(id).then((res: any) => {
      this.fileList = res.data;
      this.fileList.forEach((item: any) => {
        item.url = publishObjectPath.imgPathWater + item.path;
      });
    });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.fileList = [];
    this.visible = false;
  }
  handleSubmitBtnClick() {
    doublePrevention.getPatrolHazardImage(this.imageForm).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('上传成功');
        this.returnDialog();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.imageForm.images = arr.toString();
  }
  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.imageForm.images = arr.toString();
  }
}
